import { all } from "redux-saga/effects";
import { authUserSaga } from "./auth/saga";
import { brandsSaga } from "./brands/saga";
import { modelsSaga } from "./models/saga";
import { overviewSaga } from "./overview/saga";
import { promptsSaga } from "./prompts/saga";
import { responsesSaga } from "./response/saga";
import { scoresSaga } from "./scores/saga";
import { superuserSaga } from "./superuser/saga";
import { invitationsSaga } from "./invitations/saga";
import { agencySaga } from "./agency/saga";

export default function* rootSaga() {
  yield all([
    authUserSaga(),
    brandsSaga(),
    modelsSaga(),
    overviewSaga(),
    promptsSaga(),
    scoresSaga(),
    responsesSaga(),
    superuserSaga(),
    invitationsSaga(),
    agencySaga(),
  ]);
}